var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-button',{attrs:{"variant":_vm._model ? 'success' : null,"outline":!_vm._model,"icon":_vm._model ? 'check' : null,"disabled":_vm.disabled,"name":_vm.name},on:{"click":function($event){_vm._model = !_vm._model}}},[_vm._v("\n  "+_vm._s(_vm.label || _vm.name || _vm._model)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }